const postTenants = {
  toastr: 'Tenant adicionada',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Tenant já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postTenants;
